/** Filas de pipeline con listado de detalle disponible en popup. */
export const PYG_SERIE_DETALLE = {
  "PROYECCIÓN VENTAS": {
    endpoint: "proyeccion_ventas/detalle",
    variant: "proyeccion",
    terceroLabel: "Cliente",
    idLabel: "ID oferta (venta)",
    showDivisa: true,
  },
  "PROYECCIÓN COMPRAS": {
    endpoint: "proyeccion_compras/detalle",
    variant: "proyeccion",
    terceroLabel: "Proveedor",
    idLabel: "ID oferta (compra)",
    showDivisa: true,
  },
  "PEDIDOS VENTA": {
    endpoint: "pedidos_venta/detalle",
    variant: "documento",
    terceroLabel: "Cliente",
    showRepresentante: true,
    showDivisa: true,
  },
  "PEDIDOS COMPRA": {
    endpoint: "pedidos_compra/detalle",
    variant: "documento",
    terceroLabel: "Proveedor",
    showDivisa: true,
  },
  "FACTURAS BORRADOR VENTA": {
    endpoint: "facturas_venta_borrador/detalle",
    variant: "documento",
    terceroLabel: "Cliente",
    showDivisa: true,
  },
};

/** Títulos alternativos (PygDebug vs PyG analítico). */
const PYG_SERIE_DETALLE_ALIASES = {
  "PEDIDOS DE VENTA": "PEDIDOS VENTA",
  "PEDIDOS DE COMPRA": "PEDIDOS COMPRA",
};

export function resolvePygSerieDetalle(titulo) {
  const key = PYG_SERIE_DETALLE_ALIASES[titulo] || titulo;
  const config = PYG_SERIE_DETALLE[key];
  if (!config) return null;
  return { key, config };
}

export const hasPygSerieDetalle = (titulo) =>
  Boolean(resolvePygSerieDetalle(titulo));

/** Clave canónica para el diálogo (endpoint compartido entre vistas). */
export const getPygSerieDetalleKey = (titulo) =>
  resolvePygSerieDetalle(titulo)?.key ?? titulo;
